import React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const checkoutSearchSchema = z.object({
  program_id: z.string().optional(),
  donation_id: z.string().optional(),
  currency: z.string().optional(),
  response_message: z.string().optional(),
});

export const Route = createFileRoute("/$lang/challenge-checkout/$challengeId")({
  component: React.lazy(() =>
    import("@/pages/challenge-checkout").then((mod) => ({
      default: mod.default,
    })),
  ),
  validateSearch: (search) => checkoutSearchSchema.parse(search),
});
